import React from 'react';

import { Textarea } from '@buildoutinc/blueprint-react/ui/Textarea';

import PanelFooter from './panel_footer';

interface Props {
  buttonLabel: string;
  dateLabel: string;
  placeholder: string;
  saving: boolean;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

export default function ActivityPanel({
  buttonLabel,
  dateLabel,
  placeholder,
  saving,
  value,
  onChange,
  onSubmit,
}: Props) {
  return (
    <div className="d-flex flex-column gap-3">
      <Textarea
        placeholder={placeholder}
        rows={4}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
      />
      <PanelFooter
        buttonLabel={buttonLabel}
        dateLabel={dateLabel}
        disabled={!value.trim()}
        saving={saving}
        onSubmit={onSubmit}
      />
    </div>
  );
}
